export const JOB_QUERY_PREFIX = 'job' as const;
export const JobQueryKeys = {
	detail:   (jobId: null | string) => [ JOB_QUERY_PREFIX, 'detail', { jobId } ] as const,
	favorite: (queryParams?: Record<string, unknown>) => [ JOB_QUERY_PREFIX, 'favorite', queryParams ] as const,
	root: 		  () => [ JOB_QUERY_PREFIX ] as const,
	search:   (queryParams?: Record<string, unknown>) => [ JOB_QUERY_PREFIX, 'search', queryParams ] as const,
};
